(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-video-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-video-reviews')) {
    customElements.define('product-video-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-review-open]');
          if (trigger) {
            const dialog = document.getElementById(trigger.dataset.reviewOpen);
            if (!dialog || dialog.open) return;
            this.trigger = trigger;
            dialog.showModal();
            dialog.querySelector('video')?.play()?.catch(() => {});
          }
          if (event.target.closest('[data-review-close]')) event.target.closest('dialog')?.close();
          if (event.target instanceof HTMLDialogElement && event.target.open) {
            const rect = event.target.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
          }
        });
        this.addEventListener('close', (event) => {
          event.target.querySelector('video')?.pause();
          if (this.trigger?.isConnected) this.trigger.focus();
        }, true);
      }
      disconnectedCallback() {
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
